import dynamicAPI from './dynamicAPI';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useMessage } from '../context/AdminMessageContext';

const urlMyProfile = '/api/auth/my-profile';

export default function useMyProfileHook() {
    const queryClient = useQueryClient();
    const { setSuccessMessage, setErrorMessage } = useMessage();

    const getMyProfile = useQuery(
        ['myProfile'],
        async () => {
            const response = await dynamicAPI('get', urlMyProfile);
            if (response.error) {
                const errorMessage =
                    response.error || 'An error occurred while fetching the profile.';
                setErrorMessage(errorMessage);
                throw new Error(errorMessage);
            }
            return response;
        },
        {
            retry: 0,
            staleTime: 1000 * 15,
        }
    );

    const postMyProfile = useMutation(
        async (obj) => await dynamicAPI('post', urlMyProfile, obj),
        {
            retry: 0,
            onSuccess: (data) => {
                if (data.isSuccess || !data.error) {
                    setSuccessMessage('Profile updated successfully.');
                    queryClient.invalidateQueries(['myProfile']);
                } else {
                    const errorMessage = data.error || 'Failed to update profile.';
                    setErrorMessage(errorMessage);
                }
            },
            onError: (error) => {
                const errorMessage =
                    error?.error || 'An error occurred while updating the profile.';
                setErrorMessage(errorMessage);
            },
        }
    );

    return { getMyProfile, postMyProfile };
}
